import React from "react";
import tw from "twin.macro";
import {
  BuyNowPayLaterOutputProps,
  withBuyNowPayLater,
} from "./withBuyNowPayLater";

const Container = tw.section``;

const Wrapper = tw.div`
  flex flex-row items-center text-caption md:text-[13px] md:items-start xl:items-center xl:flex-row
`;

const ImageContainer = tw.div`
  inline-block focus:outline-none ml-micro
`;

export const BuyNowPayLater = withBuyNowPayLater(
  ({
    label,
    providers,
    costBreakdownProviders,
    className,
    costBreakdown,
  }: BuyNowPayLaterOutputProps) => {
    return (
      <Container className={className}>
        {costBreakdownProviders?.length ? (
          <Wrapper>
            <div>
              Or 4 payments of ${costBreakdown} with
              {costBreakdownProviders.map(({ title, logo }) => (
                <ImageContainer
                  data-testid="cost-breakdown-buy-now-pay-later-logo"
                  key={title}
                >
                  <img
                    alt={logo?.alt || title}
                    src={logo?.asset?.url}
                    width={logo?.displayWidth}
                    height={logo?.displayHeight}
                  />
                </ImageContainer>
              ))}
            </div>
          </Wrapper>
        ) : null}
        {providers?.length ? (
          <Wrapper>
            {label}
            <div>
              {providers.map(({ title, logo }) => (
                <ImageContainer
                  data-testid="buy-now-pay-later-logo"
                  key={title}
                >
                  <img
                    alt={logo?.alt || title}
                    src={logo?.asset?.url}
                    width={logo?.displayWidth}
                    height={logo?.displayHeight}
                  />
                </ImageContainer>
              ))}
            </div>
          </Wrapper>
        ) : null}
      </Container>
    );
  },
);

export default BuyNowPayLater;
